import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { fmtErr } from "../api";
import BrandMark from "../components/BrandMark";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
      navigate(location.state?.from || "/", { replace: true });
    } catch (err) {
      setError(fmtErr(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex" data-testid="login-page">
      <div className="hidden lg:flex w-1/2 flex-col justify-between p-12" style={{ backgroundColor: "#002B5D" }}>
        <BrandMark size={52} />
        <div>
          <h1 className="font-heading text-5xl font-extrabold text-white leading-tight tracking-tight">
            Manufacturing,<br />tracked lot by lot.
          </h1>
          <p className="mt-6 text-blue-200 max-w-md">
            Inventory, BOMs, manufacturing orders, lot traceability, QC and packing lists — one simple system for the factory floor and the office.
          </p>
          <div className="mt-10 h-1 w-24" style={{ backgroundColor: "#EB1C27" }} />
        </div>
        <div className="text-blue-300 text-xs font-mono uppercase tracking-[0.3em]">SK Zippers MES</div>
      </div>

      <div className="flex-1 flex items-center justify-center p-6 bg-slate-50">
        <div className="w-full max-w-sm">
          <div className="lg:hidden mb-8"><BrandMark size={44} dark /></div>
          <h2 className="font-heading text-2xl font-bold text-[#002B5D]">Sign in</h2>
          <p className="text-sm text-slate-500 mt-1">Use your SK Zippers account.</p>
          <form onSubmit={submit} className="mt-8 space-y-5" data-testid="login-form">
            <div>
              <label className="sk-label" htmlFor="email">Email</label>
              <input id="email" data-testid="login-email-input" type="email" required autoComplete="email"
                value={email} onChange={(e) => setEmail(e.target.value)} className="sk-input" />
            </div>
            <div>
              <label className="sk-label" htmlFor="password">Password</label>
              <input id="password" data-testid="login-password-input" type="password" required autoComplete="current-password"
                value={password} onChange={(e) => setPassword(e.target.value)} className="sk-input" />
            </div>
            {error && <div data-testid="login-error" className="text-sm text-rose-600 bg-rose-50 border border-rose-200 rounded-md px-3 py-2">{error}</div>}
            <button data-testid="login-submit-button" type="submit" disabled={busy}
              className="w-full h-11 rounded-md font-heading font-bold text-white transition-opacity disabled:opacity-60"
              style={{ backgroundColor: "#EB1C27" }}>
              {busy ? "Signing in..." : "Sign In"}
            </button>
            <div className="text-center">
              <Link to="/forgot-password" data-testid="forgot-password-link" className="text-sm text-[#002B5D] hover:underline">
                Forgot password?
              </Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
